// App.js
import React from 'react';
import Header from './components/Header/Header';
import Home from './components/Home/Home';
import Services from './components/Services/Services';
import About from './components/About/About';
import Location from './components/Location/Location';
import Contact from './components/Contact/Contact';
import WhatsAppButton from './components/WhatsApp/WhatsAppButton';
import Footer from './components/Footer/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Home />
        <Services />
        <About />
        <Location />
        <Contact />
      </main>
      <WhatsAppButton />
      <Footer />
    </div>
  );
}

export default App;